import axios from 'axios';

const api = axios.create({
  baseURL: 'https://back.digitrack.metaglobaltech.com',
  // baseURL: 'http://localhost:3334',
});

export default api;
